import { render, staticRenderFns } from "./template-publish-widget.vue?vue&type=template&id=ff151c2a&scoped=true&"
import script from "./template-publish-widget.vue?vue&type=script&lang=js&"
export * from "./template-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./template-publish-widget.vue?vue&type=style&index=0&id=ff151c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff151c2a",
  null
  
)

export default component.exports